import React from "react";
import { PageBanner } from "../../components";
import CheckoutBag from "./CheckoutBag";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import { Helmet } from "react-helmet";
import CartCheckout from "./CartCheckout";
import { ToastContainer } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: "#000",
    color: "#fff",
  },
  Container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
}));

export default function MainCheckout() {
  const classes = useStyles();
  return (
    <Box className={classes.mainContainer}>
      <Helmet>
        <title>Cart Checkout</title>
      </Helmet>
      <ToastContainer />
      <PageBanner image={"/assets/images/bg4.jpg"} title={"Cart Checkout"} />
      <div className={classes.Container}>
        <CartCheckout />
        <CheckoutBag />
      </div>
    </Box>
  );
}
